import thumb from '../../../assets/images/shortly/thumb.png';
import full01 from '../../../assets/images/shortly/full01.png';
import full02 from '../../../assets/images/shortly/full02.png';
import full03 from '../../../assets/images/shortly/full03.png';
import full04 from '../../../assets/images/shortly/full04.png';
import full05 from '../../../assets/images/shortly/full05.png';
import full06 from '../../../assets/images/shortly/full06.png';

const shortlyData = {
  name: 'Shortly',
  description:
    'A landing page for a URL Shortener service with a functional URL shortener.',
  skills: ['CSS3', 'React'],
  sources: [
    { caption: 'Home | Shortly', source: full01 },
    { caption: 'Shortened Links | Shortly', source: full02 },
    { caption: 'Statistics | Shortly', source: full03 },
    { caption: 'Home | Shortly', source: full04 },
    { caption: 'Shortened Links | Shortly', source: full05 },
    { caption: 'Statistics | Shortly', source: full06 },
  ],
  thumbnail: thumb,
  repoUrl: 'https://github.com/justsolomon/shortly',
  liveUrl: 'https://shorten-url.netlify.app/',
};

export default shortlyData;
